import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const IconGroup = SvgIcon({
    // eslint-disable-next-line max-len
    children: jsx("path", { d: "M9 6v1.992H6c-1.11 0-2.055.39-2.836 1.172-.781.781-1.172 1.727-1.172 2.836v6c0 1.11.39 2.055 1.172 2.836.781.781 1.727 1.172 2.836 1.172h6c1.11 0 2.055-.39 2.836-1.172.781-.781 1.172-1.727 1.172-2.836v-3H18c1.11 0 2.055-.39 2.836-1.172.781-.781 1.172-1.726 1.172-2.836V6c0-1.11-.39-2.055-1.172-2.836-.781-.781-1.727-1.172-2.836-1.172h-4.992c-1.11 0-2.055.39-2.836 1.172C9.39 3.945 9 4.891 9 6zm4.008-2.508H18c.688 0 1.273.25 1.758.75.5.485.75 1.07.75 1.758v4.992c0 .703-.25 1.297-.75 1.781A2.394 2.394 0 0 1 18 13.5h-4.992c-.703 0-1.297-.242-1.781-.727-.485-.484-.727-1.078-.727-1.78V6c0-.688.242-1.273.727-1.758.484-.5 1.078-.75 1.78-.75z" }),
});

export { IconGroup };
